import {
  ComponentsContainer,
  Survey,
  NotifierComponent,
  SvgBundleComponent,
} from 'survey-react-ui';
import { PageModel } from 'survey-core';
import { Fragment } from 'react';

import { SurveyPage } from '../SurveyPage/SurveyPage';
import { Content } from '../../Content';
import { Footer } from '../../Footer';

export class SurveyRoot extends Survey {
  protected renderPage(page: PageModel): JSX.Element {
    return (
      <SurveyPage
        survey={this.survey}
        page={page}
        css={this.css}
        creator={this}
      />
    );
  }

  protected renderSurvey(): JSX.Element {
    var activePage = this.survey.activePage
      ? this.renderPage(this.survey.activePage)
      : null;

    const style: any = {};
    if (!!this.survey.renderedWidth) {
      style.maxWidth = this.survey.renderedWidth;
    }
    return (
      <Fragment>
        <ComponentsContainer
          survey={this.survey}
          container={'left'}
        ></ComponentsContainer>
        <ComponentsContainer
          survey={this.survey}
          container={'center'}
        ></ComponentsContainer>
        <ComponentsContainer
          survey={this.survey}
          container={'contentTop'}
        ></ComponentsContainer>
        {activePage}
        <ComponentsContainer
          survey={this.survey}
          container={'right'}
        ></ComponentsContainer>
      </Fragment>
    );
  }

  doRender(): JSX.Element {
    let renderResult: JSX.Element | null;

    if (this.survey.state === 'completed') {
      renderResult = this.renderCompleted();
    } else if (this.survey.state === 'completedbefore') {
      renderResult = this.renderCompletedBefore();
    } else if (this.survey.state === 'loading') {
      renderResult = this.renderLoading();
    } else if (this.survey.state === 'empty') {
      renderResult = this.renderEmptySurvey();
    } else {
      renderResult = this.renderSurvey();
    }

    return (
      <Fragment>
        {this.survey.needRenderIcons ? <SvgBundleComponent /> : null}
        <Content>
          <ComponentsContainer
            survey={this.survey}
            container="header"
            needRenderWrapper={false}
          ></ComponentsContainer>
          {renderResult}
          <NotifierComponent
            notifier={this.survey.notifier}
          ></NotifierComponent>
        </Content>
        <Footer shadow>
          <ComponentsContainer
            survey={this.survey}
            container="contentBottom"
            needRenderWrapper={false}
          ></ComponentsContainer>
        </Footer>
      </Fragment>
    );
  }
}
